import { Container, Text } from '@chakra-ui/react';
import { NextPage } from 'next';
import { getSession } from 'next-auth/react';
import { useIntl } from 'react-intl';

import { withSession } from '@/lib/session';
import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import { PageTitle } from '@/components/PageTitle/PageTitle';
import Seo from '@/components/Seo';
import { SuperOffersGrid } from '@/components/SuperOffers/SuperOffersGrid';

import { SuperOffer } from '@/models/api/SuperOffer';
import { PromotionsService } from '@/services/PromotionsService';

type SuperOffersPageProps = {
    superOffer: SuperOffer;
};

export const SuperOffers: NextPage<SuperOffersPageProps> = (props) => {
    const intl = useIntl();
    const { subtitle, promotions } = props.superOffer;

    return (
        <>
            <Seo title={intl.formatMessage({ id: 'page.super-offers.title' })} />
            <Container maxW="container.md" paddingY={10}>
                <PageTitle
                    title="page.super-offers.title"
                    boxProps={{
                        mb: 4
                    }}
                />
                {subtitle && <Text textAlign="center">{subtitle}</Text>}
                <SuperOffersGrid promotions={promotions} />
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    withSession<SuperOffersPageProps>(async (context) => {
        const session = await getSession(context);
        let superOffer: SuperOffer;
        try {
            superOffer = await PromotionsService.getSuperOffers({ session });
        } catch {
            superOffer = {
                promotions: [],
                subtitle: ''
            };
        }

        return {
            props: {
                superOffer
            }
        };
    })
);

export default SuperOffers;
